/**
 * Statistics hooks using TanStack Query
 */

import { useQuery } from '@tanstack/react-query'
import { statsService } from '@/api'
import type { FunnelStats, FunnelFilterParams } from '@/types/api'

/**
 * Query keys for statistics
 */
export const statsKeys = {
  all: ['stats'] as const,
  funnel: (params: FunnelFilterParams) => [...statsKeys.all, 'funnel', params] as const,
}

/**
 * Hook to get funnel statistics
 */
export function useFunnelStats(params?: FunnelFilterParams) {
  return useQuery<FunnelStats>({
    queryKey: statsKeys.funnel(params || {}),
    queryFn: () => statsService.getFunnelStats(params),
  })
}
